import { render } from "./ChangePasswordForm.vue?vue&type=template&id=b8f66a26&scoped=true"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=js"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=js"

import "./ChangePasswordForm.vue?vue&type=style&index=0&id=b8f66a26&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8f66a26"]])

export default __exports__